import { Box, Divider, Fade, Grid, IconButton, Modal, Paper, Typography } from '@mui/material';
import { TextWithLabelInline } from '@main/components';
import WdSvgIcon from '@main/core/WdSvgIcon';

export const VersionInfoModal = ({
  title,
  subtitle,
  show = false,
  onHide = () => {},
  data = {},
}) => {
  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      className="flex justify-center items-center pt-32"
      onClose={onHide}
    >
      <Fade in={show}>
        <Box className="flex mx-4 my-4 md:my-0">
          <Paper
            className="flex flex-col relative w-full md:w-auto custom-scrollbar"
            elevation={3}
            sx={{
              minWidth: '48rem',
              minHeight: '20rem',
              maxWidth: '100rem',
              maxHeight: 'calc(100vh - 8rem)', // Ajustar la altura máxima
              overflow: 'scroll',
            }}
          >
            <div className="flex justify-end p-8 absolute top-0 right-0">
              <IconButton aria-label="close" size="small" onClick={onHide}>
                <WdSvgIcon className="text-32" size={24} color="action">
                  material-solid:close
                </WdSvgIcon>
              </IconButton>
            </div>
            <div className="container p-20">
              <Typography variant="h6" className="flex justify-center">
                {title}
              </Typography>
              <Typography className="flex justify-center pb-14 font-bold text-lg">{`"${subtitle}"`}</Typography>
              <div className="flex justify-center pb-14 font-bold text-lg">
                {data?.description && (
                  <TextWithLabelInline label="Descripción" value={data?.description} />
                )}
              </div>

              <Divider />
              <Box className="mx-24">
                <Grid container spacing={2}>
                  {data?.api && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        API
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={data.api.repo} />
                      {/* <TextWithLabelInline label="Last Name" value={data.api.lastName} /> */}
                      {/* <TextWithLabelInline label="Name" value={data.api.name} /> */}
                      {/* <TextWithLabelInline label="Owner" value={data.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={data.api.tag} />
                    </Grid>
                  )}
                  {data?.manager && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Manager
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={data.manager.repo} />
                      {/* <TextWithLabelInline
                        label="Last Name"
                        value={data.manager.lastName}
                      /> */}
                      {/* <TextWithLabelInline label="Owner" value={data.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={data.manager.tag} />
                    </Grid>
                  )}
                  {data?.notify && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Notify
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={data.notify.repo} />
                      {/* <TextWithLabelInline label="Last Name" value={data.notify.lastName} /> */}
                      {/* <TextWithLabelInline label="Owner" value={data.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={data.notify.tag} />
                      {/* <TextWithLabelInline label="NodeJS" value={data.notify.nodejs} /> */}
                    </Grid>
                  )}
                  {data?.terminals && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Terminals
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={data.terminals.repo} />
                      {/* <TextWithLabelInline
                        label="Last Name"
                        value={data.terminals.lastName}
                      /> */}
                      {/* <TextWithLabelInline label="Name" value={data.api.name} />
                      <TextWithLabelInline label="Owner" value={data.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={data.terminals.tag} />
                    </Grid>
                  )}
                  {data?.['face-recognition-server'] && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Face Recognition Server
                      </Typography>
                      <TextWithLabelInline
                        label="Repositorio"
                        value={data['face-recognition-server'].repo}
                      />
                      <TextWithLabelInline
                        label="Tag"
                        value={data['face-recognition-server'].tag}
                      />
                    </Grid>
                  )}
                  {data?.['fingerprint-recognition-server'] && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Fingerprint Recognition Server
                      </Typography>
                      <TextWithLabelInline
                        label="Repositorio"
                        value={data['fingerprint-recognition-server'].repo}
                      />
                      <TextWithLabelInline
                        label="Tag"
                        value={data['fingerprint-recognition-server'].tag}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </div>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
};
